import { render, staticRenderFns } from "./box.vue?vue&type=template&id=ae4b1a04&"
import script from "./box.ts?vue&type=script&lang=ts&"
export * from "./box.ts?vue&type=script&lang=ts&"
import style0 from "./box.vue?vue&type=style&index=0&id=ae4b1a04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports